import { Ref, useCallback, useRef, useState } from 'react'

export const useHasIntersected = (
  rootMargin: IntersectionObserverInit['rootMargin'] = '200px',
  threshold: IntersectionObserverInit['threshold'] = 0,
) => {
  const intersectionObserver = useRef<IntersectionObserver | null>(null)
  const [state, setState] = useState(false)

  const ref: Ref<HTMLElement | null> = useCallback((element: HTMLElement | null) => {
    if (intersectionObserver.current) {
      intersectionObserver.current.disconnect()
    }

    intersectionObserver.current = new IntersectionObserver(
      ([entry]) => setState(prev => prev || entry.isIntersecting),
      {
        root: null,
        rootMargin,
        threshold,
      },
    )

    if (element) {
      intersectionObserver.current.observe(element)
    }
  }, [rootMargin, threshold])

  return [ref, state] as const
}
